export enum BigBlueButtonStateEnum {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
}
